module.exports = __webpack_public_path__ + "img/buy_mint_booster_nft_button.35f78bf5.png";